// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"ManageComments_PageHolder__1GgRF","TotalScore":"ManageComments_TotalScore__1NAfM","Rate":"ManageComments_Rate__MEG4o"};